import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { AccessLog } from 'src/app/core/models/logs/access-log.model';
import { ValueGraph } from 'src/app/core/models/logs/value-graph.model'
import { PropertyType } from 'src/app/core/models/project/property-type.model';
import { Property } from 'src/app/core/models/project/property.model';
import { SsFilterSort } from 'src/app/core/models/ss-filter-sort.model';
import { DateTimeFromToComponent } from 'src/app/modules/logs/components/date-time-from-to/date-time-from-to.component';
import { ApiAlarmLogsService } from 'src/app/modules/logs/services/http/api-alarm-logs.service';
import { ApiProjectService } from 'src/app/modules/project/services/http/api-project.service';

@Component({
  selector: 'app-io-common-area-modal-log',
  templateUrl: './io-common-area-modal-log.component.html',
  styleUrls: ['./io-common-area-modal-log.component.scss']
})
export class IOCommonAreaModalLogComponent implements OnInit {

  @ViewChild('dateTimeFromTo') dateTimeFromTo: DateTimeFromToComponent;
  @ViewChild('tablePropertiesSelect') tablePropertiesSelect: any;
  @Input() controllers: Controller[];
  private readonly EQUIPMENT_PROPERTY_TYPES_URL: string = 'assets/cntproptypes.json';
  activeCard: string = 'value';
  propertiesList: Array<any>;

  // graph
  graphCreated = false;
  tableCreated = true;
  tempGraph: any[];
  circumstancesGraph: any[];
  tableData: any = [];
  tableProperties: string[] = [];
  selectedController: Controller;

  body: ValueGraph = new ValueGraph;

    // options
  legend = true;
  xAxis = true;
  yAxis = true;
  showYAxisLabel = true;
  showXAxisLabel = true;
  xAxisLabel = 'Time';
  yAxisLabel = 'Values';
  timeline = false;
  // colorScheme = {domain: ['#6BA0C4', '#03143A']};


  hideCustomTime = true;
  tempEvent: CustomEvent;
  showSelect = true;

  Property = Property;

  propSelect: any;

  //event log
  page = 1;
  giveAccess: boolean = false;
  giveAlarm: boolean = false;
  logsLoading = false;

  accessCheckbox = false;
  alarmCheckbox = false;

  queryParams = {
    pageNumber: 1,
    pageSize: 10000,
    includeArchive: false
  };


  constructor(private apiProjectService: ApiProjectService,
              private apiAlarmLogsService: ApiAlarmLogsService,
              private http: HttpClient) { }

  ngOnInit(): void {
    this.selectedController = this.controllers[0];
    this.http.get<any>(this.EQUIPMENT_PROPERTY_TYPES_URL).subscribe( resp => {
      this.propertiesList = resp.Definitions;
    })
  }

  cardClicked(card: string) {
    this.activeCard = card;
    this.tableProperties = [];
    if (this.activeCard === 'temperature') {
      this.createGraph();
    }
    if (this.activeCard === 'fullGraph') {
      setTimeout (() => {
        this.showLast7days();
      },200)
    }
  }

  getPropertyName(propType: string) {
    const target = this.propertiesList.find( (prop: PropertyType) => {
      if (+propType >= prop.CodeFrom && +propType <= prop.CodeTo) { return true}
    })

    if (propType) {
      if (target) {
        return target.Name;
      } else {
        return 'Unknown property';
      }
    } else {
      return null;
    }
  }

  createGraph() {
    this.logsLoading = true;
    this.body.controllerDesignations = [];
    this.body.controllerDesignations.push(this.selectedController.designation);
    if (this.activeCard === 'temperature') {
      this.graphCreated = false;
      this.body.properties = ["6250", "6200", ...this.tableProperties];
    }
    if (this.activeCard === 'fullGraph') {
      this.tableCreated = false;
      this.body.properties = this.tableProperties;
    }

    if ((this.tableProperties.length > 0 && this.activeCard === 'fullGraph') || this.activeCard === 'temperature') {
      this.apiProjectService.getGraph(this.body).subscribe( response => {
        if (response) {
          if (this.activeCard === 'temperature') {
            this.tempGraph = this.createDataFromResponse(response);
            this.graphCreated = true;
          }

          if (this.activeCard === 'fullGraph') {
            this.tableData = this.reduceDataForTableView(response);
            this.getAlarmAndAcessLogs();
          }
        } else {
          this.graphCreated = false;
        }
      });
    } else {
      this.getAlarmAndAcessLogs();
    }
  }

  reduceDataForTableView(response: any) {
    const tempData = [];
    this.tableProperties.forEach( prop => {
      response.forEach( (element , index) => {
        if ((index === 0 && element.propertyType === prop) || (element.propertyType === prop && response[index].value !== response[index-1].value)) {
            tempData.push(element);
        }
      });
    })
    return tempData;
  }

  createDataFromResponse(resp: any) {
    let results = [];
    this.body.properties.forEach( prop => {
      results.push({name: this.getPropertyName(prop), series: []})
    })

    resp.forEach( data => {
      const target = results.find( element => {
       if (element.name === this.getPropertyName(data.propertyType)) { return true;}
      })
      target.series.push({name: new Date(data.timestamp), value: data.value})
    });
    if (this.activeCard === 'temperature') {
      this.circumstancesGraph = [];
      this.tableProperties.forEach( propType => {
        const prop = this.selectedController.controllerProperties.$values.find (p => p.type === +propType);
        if (prop) {
          this.circumstancesGraph.push(...results.filter( data => data.name === this.getPropertyName(prop.type.toString())));
        }
        results = results.filter( data => data.name !== this.getPropertyName(propType));
      })
    }
    return results;
  }

  yAxisTickFormatting = (value) => {
    if (value === 0) {
      return `Closed`
    }
    if (value === 1) {
      return `Open`
    }
  };

  setDateTimeFromTo(selectedDateTime: Date[]) {
    if (!(selectedDateTime[0] === undefined || selectedDateTime[0] === null) && !(selectedDateTime[1] === undefined || selectedDateTime[1] === null)) {
      this.body.dateTimeFrom = selectedDateTime[0].toISOString();
      this.body.dateTimeTo = selectedDateTime[1].toISOString();
      this.createGraph();
    }
  }

  getAlarmAndAcessLogs() {
    if (this.accessCheckbox) {
    }
    if (this.alarmCheckbox) {
      this.removeAlarmLog()
      this.getAlarmLog(1)
    }

    if (!this.alarmCheckbox && !this.accessCheckbox) {
      this.tableCreated = true;
      this.logsLoading = false;
    }
  }


  showLast24hours() {
    this.dateTimeFromTo.showLast24hours();
  }

  showLast7days() {
    this.dateTimeFromTo.showLast7days();
  }

  showLast30days() {
    this.dateTimeFromTo.showLast30days();
  }

  selectChanged(event: CustomEvent) {
    // saving last selected props for more user friendly exp when swaping controllers
    this.tempEvent = event;
    this.runEventCode(event);
    this.createGraph();
  }

  runEventCode(event: CustomEvent) {
    this.tableProperties = [];
    this.selectedController.controllerProperties.$values.forEach ( prop => {
      let target: Property;
      event.detail.value.forEach( value => {
        target = value(prop);
        if(target && this.tableProperties.indexOf(prop.type.toString()) === -1) {
          this.tableProperties.push(prop.type.toString());
        }
      });
    })
  }

  controllerChanged(controller: Controller) {
    this.selectedController = controller;
    if (this.tempEvent) {
      this.runEventCode(this.tempEvent);
    }
    this.createGraph()

    //force ion-select update when swaping controllers
    this.showSelect = false
    setTimeout( () => {
      this.showSelect = true;
    },100)
  }

  propertyExistInController(func: Function) {
    let exists = false;
    this.selectedController.controllerProperties.$values.forEach ( prop => {
      let target: Property;
      target = func(prop);
      if (target) {
        exists = true;
      }
    })
    return exists;
  }


  showCustom() {
    if (this.hideCustomTime === true) {
      this.hideCustomTime = false;
    } else {
      this.hideCustomTime = true;
      this.dateTimeFromTo.showLast7days();
    }
  }


  onAlarmLogClick(event: any) {
    if (event.target.checked) {
      this.alarmCheckbox = true;
      this.createGraph()
    } else {
      this.alarmCheckbox = false;
      this.removeAlarmLog()
      this.giveAlarm = false;
    }
  }



  getAlarmLog(pageNumber: number) {
    this.tableCreated = false;
    this.logsLoading = true;
    const requestBody: SsFilterSort = new SsFilterSort();
    requestBody.dateTimeFrom = this.body.dateTimeFrom;
    requestBody.dateTimeTo = this.body.dateTimeTo;
    // requestBody.locationDesignations.push(this.selectedController.locationId);


    this.queryParams.pageNumber = pageNumber;


    this.apiAlarmLogsService.getAlarmLogs(requestBody, this.queryParams).subscribe(resp => {
      let alarmLogData = resp.body;
      const paginationData = JSON.parse(resp.headers.get('X-Pagination'));
      alarmLogData = alarmLogData.filter( alarm => {
          if (alarm.data.includes(this.selectedController.designation)) {
            return true;
          }
        })

        this.combineData(null, alarmLogData);
        if (paginationData.HasNext) {
          this.getAlarmLog(paginationData.CurrentPage + 1)
        } else {
          this.sortTable();
          this.giveAlarm = true;
        }
    });
  }

  combineData(accessData?: AccessLog[], alarmData?: any) {
    if(alarmData) {
      alarmData.forEach( data => {
        this.tableData.push({timestamp: new Date(data.timestamp), level: data.level, description: data.description, type: 'alarm'})
      })
    }
  }


  removeAlarmLog() {
    this.tableData = this.tableData.filter( element => element.type !== 'alarm');
  }

  sortTable() {
    this.tableData.sort( (a, b) => {
      return <any>new Date(a.timestamp) - <any> new Date(b.timestamp)
    })
    this.logsLoading = false;
    this.tableCreated = true;
  }

  onPageChange(value: any) {
    this.page = value
  }

  showDataAtPage(index: number) {
    if (index === 0 && this.page === 1) {
      return true
    } else {
      const value = index / 50;
      return (this.page === Math.ceil(value))
    }
  }
}
